import { type ReactElement } from 'react';
import dynamic from 'next/dynamic';

import { type MatchStatistic } from '@common/clients/api';
import { ComponentErrorBoundary } from '@common/molecules/ComponentErrorBoundary';

import { StatsDisplay } from '../MatchStatistics.types';

const DynamicStatsBarChart = dynamic(() =>
    import('@web/molecules/StatsBarChart').then((mod) => mod.StatsBarChart),
);
const DynamicStatsPiechart = dynamic(() =>
    import('@web/molecules/StatsPiechart').then((mod) => mod.StatsPiechart),
);

type TitleTypeProp<T> = Omit<MatchStatistic, 'type'> & {
    title: T extends ReactElement ? T : string;
};

export interface Props<T> extends TitleTypeProp<T> {
    displayType?: StatsDisplay;
}

export const Chart = <T extends void | ReactElement>({
    awayValue,
    displayType,
    homeValue,
    title,
}: Props<T>) => {
    switch (displayType) {
        case StatsDisplay.PIE_CHART:
            return (
                <ComponentErrorBoundary title={'boundaryError.pieChart'}>
                    <DynamicStatsPiechart title={title} primaryValue={homeValue} secondaryValue={awayValue} />
                </ComponentErrorBoundary>
            );
        case StatsDisplay.BAR_CHART:
        default:
            return (
                <ComponentErrorBoundary title={'boundaryError.barChart'}>
                    <DynamicStatsBarChart title={title} primaryValue={homeValue} secondaryValue={awayValue} />
                </ComponentErrorBoundary>
            );
    }
};
